import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Chip,
  Button
} from '@mui/material';
import { PersonAdd } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const KarigarForm = () => {
  return (
    <Container maxWidth={false} disableGutters sx={{ py: 0, px: 0 }}>
      <Box sx={{ mb: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => window.history.back()} variant="outlined" color="primary">
          Back
        </Button>
      </Box>
      <Box textAlign="center" mb={4}>
        <PersonAdd sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom>
          Karigar Management
        </Typography>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          Comprehensive Karigar Registration & Management System
        </Typography>
        <Chip 
          label="Coming Soon" 
          color="primary" 
          variant="outlined" 
          sx={{ mt: 2 }}
        />
      </Box>

      <Paper elevation={3} sx={{ p: 0 }}>
        <Typography variant="h4" gutterBottom>
          Module Overview
        </Typography>
        <Typography variant="body1" paragraph>
          The Karigar Management module will provide a comprehensive solution for managing all aspects of karigar operations. 
          From initial registration to ongoing work management, this system will streamline the entire karigar workflow.
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
          Key Features:
        </Typography>
        <ul>
          <li>Add new karigars with personal details</li>
          <li>Assign work orders and track progress</li>
          <li>Manage karigar schedules and availability</li>
          <li>Track payments and wages</li>
          <li>Generate performance reports</li>
          <li>Monitor work quality and completion rates</li>
          <li>Handle multiple karigar types (Gold, Silver, etc.)</li>
          <li>Integration with order management system</li>
        </ul>
      </Paper>
    </Container>
  );
};

export default KarigarForm; 